export default __webpack_public_path__ + "static/library@2x-1e2dd85ea3024bfaf2b1f88d24513d37.png";